import { render, staticRenderFns } from "./StockMovementItem.component.vue?vue&type=template&id=b5b33ae6&scoped=true&"
import script from "./StockMovementItem.component.vue?vue&type=script&lang=js&"
export * from "./StockMovementItem.component.vue?vue&type=script&lang=js&"
import style0 from "./StockMovementItem.component.vue?vue&type=style&index=0&id=b5b33ae6&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b33ae6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VRow,VTooltip})
